import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FetchAnnouncementService } from './fetch-announcements.service';
import { MatDialog } from '@angular/material/dialog';
import { FetchDashboardService } from '../../admin/fetch-dashboard.service';
import { Balance, Top10 } from '../seller';
import { WithdrawalStatusService } from '../../../shared/services/withdrawal-status.service';
import { AnnouncementDialogComponent } from '../../../shared/components/announcement-dialog/announcement-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ActivationStepsService } from 'src/app/shared/services/activation-steps.service';
import { ListBankAccountsService } from '../financials/services/list-accounts.service';
import { GetBusinessProfileService } from 'src/app/shared/services/get-business-profile.service';
import { FetchSellerBalanceService } from './fetch-seller-balance.service';
import { GetStatusProfileService } from '../../admin/action/components/crm/profile/services/get-status-profile.service';
import { LanguageService } from '../../../shared/services/language.service';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
import { MissingDataSectionNotifierService } from '../my-account/services/missingDataSectionNotifier.service';
import { ContractStatusNotifierService } from '../my-account/services/contractStatusNotifier.service';
import { AuthService } from 'src/app/shared/services/auth.service';
declare let $: any;

@Component({
  selector: 'app-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss']
})
export class SellerComponent implements OnInit {
  balanceObject: Balance;
  show: boolean = false;
  displayedColumns = ['ProductName', 'SalesCount', 'SalesAmount'];
  showContractAlert: boolean = false;
  datasource: Array<Top10> = [];
  topSellingProductLastMonth: any;
  topSellingProductLast6Months: any;
  dashboardResult!: DashboardResponseModel;
  isUnVerified:boolean = false;
  activationStep: boolean;
  businessBanks:IBankAcconts;
  business: IBusiness;
  showAddData:boolean;
  hasDashboardPermission: boolean = true;
  isNewSellerRole:boolean;
  isMissingDataSection:boolean=true;
  businessActiveStatus: string;
  businessContractStatus: string;
  constructor( private dashboardService: FetchDashboardService,
    private announcementService: FetchAnnouncementService,
    private withdrawalStatusService: WithdrawalStatusService,
    private announcementDialog: MatDialog,
    private fetchBalanceService: FetchSellerBalanceService,
    public translate: TranslateService,
    public languageService: LanguageService,
    private activationStepsService: ActivationStepsService,
    private listBusinessBanks: ListBankAccountsService,
    private businessProfile: GetBusinessProfileService,
    private missingDataSectionNotifier: MissingDataSectionNotifierService,
    private contractStatusNotifier:ContractStatusNotifierService,
    private authService: AuthService
  ) {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        translate.use('ar');
        document.body.classList.add('dir-rtl');
      } else if (localStorage.getItem("language") === "en") {
        translate.use('en');
        document.body.classList.remove('dir-rtl');
      }
    } else {
      translate.use('en');
      document.body.classList.remove('dir-rtl');
    }
  }

  async ngOnInit() {
    this.contractStatusNotifier
      .getStatusNotification()
      .subscribe((res: string) => {
        this.businessContractStatus = res;
      });
    if (localStorage.getItem("language")) {
      this.translate.use(localStorage.getItem("language"));
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });
    await this.assignBusinessAndSeller();
    this.hasDashboardPermission =
      await this.authService.hasPermissionAction('seller.dashboard');
    if(!this.hasDashboardPermission) return;
    await this.showDashboard();
      this.missingDataSectionNotifier.isMissingDataRecieveNotification().subscribe((res:boolean)=>{
        this.isMissingDataSection=res;
      });
    if (this.dashboardService.getAlertFlag()) {
      this.showContractAlert = true;
      this.dashboardService.setAlertFlag(false);
    }

    this.withdrawalStatusService.refetchBS.next(true);
    this.dashboardResult = await this.dashboardService.make();
    if (this.dashboardResult.isSeller && this.dashboardResult.container.Top10) {
      this.datasource = this.dashboardResult.container.Top10.map(i => {
        return {
          ProductName: i.productName,
          SalesCount: i.salesCount,
          SalesAmount: i.salesAmount,
          productType: i.productTypeName
        } as Top10;
      });

      this.topSellingProductLastMonth = this.dashboardResult.container.topProductLastMonth

      this.topSellingProductLast6Months = this.dashboardResult.container.topProductLast6Months

      if (this.dashboardResult.container.last6Month) {
        let monthNameChart: string[] = this.dashboardResult.container.last6Month.map(i => i.monthName).reverse();
        const dataChart: number[] = this.dashboardResult.container.last6Month.map(i => Number(i.totalSales)).reverse();
        this.initLast6MonthSalesChart(monthNameChart, dataChart);
      }
    }

    // Fetching balance
    this.balanceObject = await this.fetchBalanceService.make();
    await this.openAnnouncementPopup();
    let balanceData: number[] = [
      this.balanceObject.pendingBalance,
      this.balanceObject.avalibleBalance,
      this.balanceObject.totalBalnce
    ];
    this.initBalanceChart(balanceData)
  }

  async assignBusinessAndSeller(){
    /* Get And Assign Business Required For The Rest of the Component
     But Needed Her To Get The Seller*/
    this.business = await this.businessProfile.make();
    this.businessActiveStatus=this.business.Business.activeStatus;
    this.businessContractStatus= this.business.Business.contractStatus;
    //Get Stautsprofile That Include Getting Business and seller
    const roleId = (await this.authService.getRole()).id;
    //If The Seller is new Seller Don't Show BusinessDashboardCheck Comp AKa please Fill The Missing Data
    this.isNewSellerRole = roleId == 16 ? true : false;
  }
  async showDashboard() {
    const businessDataIntegrety: boolean = await this.checkBusinessData();
    if (businessDataIntegrety) {
      this.show = true;
    } else {
      this.show = false;
      this.showAddData = true
    }
  }

  async openAnnouncementPopup() {
    const result = await this.announcementService.make();
    let remainingAnnouncementCount = result.remainingCount;
    if (result.announcement) {
      const dialogRef = this.announcementDialog.open(AnnouncementDialogComponent, {
        width: '70%',
        data: {
          message: `${result.announcement.announcementBody}`,
          question: true,
          title: `${result.announcement.announcementSubject}`,
          lang: `${result.announcement.lang}`
        }
      });
      const r = await dialogRef.afterClosed().toPromise();
      if (!r) {
        remainingAnnouncementCount = 0;
      }
    }
  }

  initLast6MonthSalesChart(monthNames: string[], data: number[]) {
    let monthNamesAr: string[] = [];
    var ctx = (document.getElementById('kt_flotcharts_6') as HTMLCanvasElement).getContext('2d');
    var monthSalesChart: Chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: monthNames,
        datasets: [{
          label: 'Total Sales',
          data: data,
          backgroundColor: '#e43f52',
          fill: true,
          cubicInterpolationMode: 'monotone',
          tension: 0.4
        }]
      },
      options: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: 'Last 6 Month Sales'
          },
          tooltip: {
            mode: 'index'
          },
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Month'
            }
          },
          y: {
            stacked: true,
            title: {
              display: true,
              text: 'Sales'
            }
          }
        }
      }
    });
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === 'ar') {
        monthNames.forEach((month: string) => {
          switch (month) {
            case 'January':
              month = 'يناير';
              break;
            case 'February':
              month = 'فبراير';
              break;
            case 'March':
              month = 'مارس';
              break;
            case 'April':
              month = 'إبريل';
              break;
            case 'May':
              month = 'مايو';
              break;
            case 'June':
              month = 'يونيو';
              break;
            case 'July':
              month = 'يوليو';
              break;
            case 'August':
              month = 'أغسطس';
              break;
            case 'September':
              month = 'سبتمبر';
              break;
            case 'October':
              month = 'أكتوبر';
              break;
            case 'November':
              month = 'نوفمبر';
              break;
            case 'December':
              month = 'ديسمبر';
              break;
            default:
              month = month;
              break;
          }
          monthNamesAr.push(month);
        });
        this.updateLast6MonthSalesChartAr(monthNamesAr, monthSalesChart);
      } else {
        this.updateLast6MonthSalesChart(monthNames, monthSalesChart);
      }
      this.translate.use(localStorage.getItem("language"));
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      if (lang === 'ar') {
        monthNames.forEach((month: string) => {
          switch (month) {
            case 'January':
              month = 'يناير';
              break;
            case 'February':
              month = 'فبراير';
              break;
            case 'March':
              month = 'مارس';
              break;
            case 'April':
              month = 'إبريل';
              break;
            case 'May':
              month = 'مايو';
              break;
            case 'June':
              month = 'يونيو';
              break;
            case 'July':
              month = 'يوليو';
              break;
            case 'August':
              month = 'أغسطس';
              break;
            case 'September':
              month = 'سبتمبر';
              break;
            case 'October':
              month = 'أكتوبر';
              break;
            case 'November':
              month = 'نوفمبر';
              break;
            case 'December':
              month = 'ديسمبر';
              break;
            default:
              month = month;
              break;
          }
          monthNamesAr.push(month);
        });
        this.updateLast6MonthSalesChartAr(monthNamesAr, monthSalesChart);
      } else {
        this.updateLast6MonthSalesChart(monthNames, monthSalesChart);
      }
      this.translate.use(lang);
    });
  }

  updateLast6MonthSalesChart(monthNames: string[], monthSalesChart: Chart) {
    let totalSalesLabel: string = 'Total Sales';
    let monthLabel: string = 'Month';
    let salesLabel: string = 'Sales';
    monthSalesChart.data.labels = monthNames;
    monthSalesChart.data.datasets[0].label = totalSalesLabel;
    monthSalesChart.options.plugins.title.text = 'Last 6 Month Sales';
    monthSalesChart.options.scales.x['title'].text = monthLabel;
    monthSalesChart.options.scales.y['title'].text = salesLabel;
    monthSalesChart.update();
  }

  updateLast6MonthSalesChartAr(monthNames: string[], monthSalesChart: Chart) {
    let totalSalesLabel:string = 'إجمالي المبيعات';
    let monthLabel: string = 'الشهر';
    let salesLabel: string = 'المبيعات';
    monthSalesChart.data.labels = monthNames;
    monthSalesChart.data.datasets[0].label = totalSalesLabel;
    monthSalesChart.options.plugins.title.text = 'مبيعات آخر 6 أشهر';
    monthSalesChart.options.scales.x['title'].text = monthLabel;
    monthSalesChart.options.scales.y['title'].text = salesLabel;
    monthSalesChart.update();
  }

  initBalanceChart(balanceData: number[]) {
    let balanceChartCanvas = (document.getElementById('balance-chart') as HTMLCanvasElement).getContext('2d');
    let balanceLabel: string[] = [
      'Pending Balance',
      'Available Balance',
      'Total Balance',
    ];
    let datasetLabel: string = "Total Balance";
    var balanceChart: Chart = new Chart(balanceChartCanvas, {
      type: 'doughnut',
      data: {
        labels: balanceLabel,
        datasets: [{
          label: datasetLabel,
          data: balanceData,
          backgroundColor: ['#f17425', '#45aae2', '#2eca8b'],
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: datasetLabel
          }
        }
      },
    });
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === 'ar') {
        this.updateBalanceChartAr(balanceChart);
      } else {
        this.updateBalanceChart(balanceChart);
      }
      this.translate.use(localStorage.getItem("language"));
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      if (lang === 'ar') {
        this.updateBalanceChartAr(balanceChart);
      } else {
        this.updateBalanceChart(balanceChart);
      }
      this.translate.use(lang);
    });
  }

  updateBalanceChart(balanceChartCanvas: Chart) {
    let balanceLabel: string[] = [
      'Pending Balance',
      'Available Balance',
      'Total Balance',
    ];
    let datasetLabel: string = "Total Balance";
    balanceChartCanvas.data.labels = balanceLabel;
    balanceChartCanvas.data.datasets[0].label = datasetLabel;
    balanceChartCanvas.options.plugins.title.text = datasetLabel;
    balanceChartCanvas.update();
  }

  updateBalanceChartAr(balanceChartCanvas: Chart) {
    let balanceLabelAr: string[] = [
      'الرصيد المعلق',
      'الرصيد المتوفر',
      'إجمالي الرصيد',
    ];
    let datasetLabelAr: string = "إجمالي الرصيد";
    balanceChartCanvas.data.labels = balanceLabelAr;
    balanceChartCanvas.data.datasets[0].label = datasetLabelAr;
    balanceChartCanvas.options.plugins.title.text = datasetLabelAr;
    balanceChartCanvas.update();
  }

  closeAlert() {
    this.showContractAlert = false;
  }
  onManualDownload() {
    this.dashboardService.setmanualPrintFlag(true);
  }

  async checkBusinessData(): Promise<boolean> {
    if (this.business)this.isUnVerified = this.businessValueCheck();
    this.activationStepsService.setActivationSteps();
    this.activationStep = this.activationStepsService.getVerifyFacebookStep ;
    this.businessBanks = await this.listBusinessBanks.make();
    if (
      this.isUnVerified ||
      !this.activationStep ||
      this.businessBanks.totalNumberOfRows == 0
    ) {
      return false;
    }
    return true;
  }

  businessValueCheck(): boolean {
    if (this.business.Business.activeStatus !== 'Active' &&
      this.business.Business.activeStatus !== 'Verified') return false;
    if (!this.business.Business.CategoryId) return true;
    if (!this.business.Business.logo) return true;
    if (!this.business.Business.name) return true;
    return false;
  }
}

interface DashboardResponseModel {
  isSeller: boolean;
  container: {
    cards: {
      dailySalesAmount?: number;
      dailySalesCount?: number;
      monthlySalesAmount?: number;
      monthlySalesCount?: number;
      dailyProductsCount?: number;
      monthlyProductCount?: number;
      dailyUserCount?: number;
      monthlyUserCount?: number;
    },
    Top10?: [
      {
        businessName: string;
        code: string;
        creation: string;
        expired: boolean
        id: number
        isDeletable: boolean
        isEditable: boolean
        isPublishable: boolean
        productTypeId: number
        productTypeName: string
        salesAmount: number
        salesCount: number
        visitedCount: number
        productName: string
      }
    ],
    last6Month?: [
      {
        createdAt: string;
        m: number;
        monthName: string;
        totalSales: number;
      }
    ],
    topProductLastMonth?: [
      {
        businessName: string;
        code: string;
        creation: string;
        expired: boolean
        id: number
        isDeletable: boolean
        isEditable: boolean
        isPublishable: boolean
        productTypeId: number
        productTypeName: string
        salesAmount: number
        salesCount: number
        visitedCount: number
        productName: string
      }
    ]
    topProductLast6Months?: [
      {
        businessName: string;
        code: string;
        creation: string;
        expired: boolean
        id: number
        isDeletable: boolean
        isEditable: boolean
        isPublishable: boolean
        productTypeId: number
        productTypeName: string
        salesAmount: number
        salesCount: number
        visitedCount: number
        productName: string
      }
    ]
  };

}

interface IBankAcconts {
  totalNumberOfRows : number;
  result : Array<IBank>
}

interface IBank {
  id : number;
  status : string;
  createdAt : Date;
  Businessid : number;
  holder_name: string;
  account_number : string;
  english_branch_name : string;
  bank_name : string;
  arabic_bank_name : string;
}

interface IBusiness {
  [key: string]: any;
  Business:Business
}

interface Business{
  id: number;
  name: string;
  logo: string;
  activeStatus: string;
  CategoryId: number;
  link_fb: string;
  contractStatus: string;
}
